<template>
  <div class="terrain-attachment-field">
    <AttachmentEditor
      v-if="canUpload && !readonly"
      :question="question"
      :value="value"
      :campaign-id="campaignId"
      :template-version-id="templateVersionId"
      @input="$emit('input', $event)"
    />
    <template v-else>
      <p v-if="!attachmentIds.length" class="terrain-attachment-field__empty">Sin adjuntos.</p>
      <AttachmentGallery
        v-else
        :attachment-ids="attachmentIds"
        :attachment-names="attachmentNames"
        :kind="question.type"
        :label="question.label"
      />
      <button
        v-if="editable"
        type="button"
        class="terrain-attachment-field__edit-btn"
        @click="openEditor"
      >
        <font-awesome-icon icon="pen" /> Editar adjuntos
      </button>
    </template>
  </div>
</template>

<script>
import AttachmentGallery from '../AttachmentGallery.vue';
import AttachmentEditor from './AttachmentEditor.vue';

// AttachmentField enruta una respuesta file/photo entre tres modos, según
// canUpload/editable (ver AttachmentEditor.vue para la lógica de
// subida/quita real):
//   - canUpload && !readonly (modo respond): AttachmentEditor inline, sin
//     chrome de modal — subir/quitar directo en el formulario.
//   - editable && !canUpload (corrección desde la cola de revisión):
//     AttachmentGallery de solo-vista + botón "Editar adjuntos" que abre el
//     mismo AttachmentEditor dentro de un modal dinámico. onChange es el
//     callback-prop que reemplaza a $emit ahí (ver AttachmentEditor.vue).
//   - ninguno de los dos (revisión de solo lectura): solo AttachmentGallery.
export default {
  name: 'AttachmentField',
  components: { AttachmentGallery, AttachmentEditor },
  props: {
    question: { type: Object, required: true },
    value: { default: null },
    campaignId: { type: String, default: null },
    templateVersionId: { type: String, default: null },
    canUpload: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    editable: { type: Boolean, default: false },
  },
  computed: {
    attachmentIds() { return (this.value && this.value.attachmentIds) || []; },
    attachmentNames() { return (this.value && this.value.attachmentNames) || {}; },
  },
  methods: {
    openEditor() {
      this.$modal.show(AttachmentEditor, {
        question: this.question,
        value: this.value,
        campaignId: this.campaignId,
        templateVersionId: this.templateVersionId,
        showHeader: true,
        label: this.question.label,
        onChange: (value) => this.$emit('input', value),
      }, {
        name: 'terrain-attachment-editor',
        width: '90%',
        maxWidth: 700,
        height: '85%',
        adaptive: false,
        scrollable: true,
        clickToClose: true,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.terrain-attachment-field { display: grid; gap: var(--terrain-space-sm); }

.terrain-attachment-field__empty { color: var(--color-ghost); font-size: var(--terrain-font-caption); margin: 0; }

.terrain-attachment-field__edit-btn {
  align-items: center;
  background: var(--color-white);
  border: 1px solid var(--color-line);
  border-radius: var(--terrain-radius-xl);
  color: var(--color-navy);
  cursor: pointer;
  display: inline-flex;
  font-weight: 600;
  gap: var(--terrain-space-xs);
  justify-self: start;
  padding: var(--terrain-space-sm) var(--terrain-space-md);
  transition: background-color var(--terrain-transition), border-color var(--terrain-transition);

  &:hover { background: var(--color-mist); border-color: var(--color-steel); }
}
</style>
